import { iocContainer } from '@ioc/ioc'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router'
import 'reflect-metadata'

import { IoCContextProvider } from '@writefull/core'

import { initializeInfrastructure, registerInfrastructure } from '@infrastructure/index'

import ErrorBoundary from '@ui/shared/components/ErrorBoundary'

import App from './ui/app/App'

import './styles/index.css'

const version = process.env.VERSION!
registerInfrastructure(iocContainer, import.meta.env, version)
initializeInfrastructure(iocContainer)

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <IoCContextProvider container={iocContainer}>
      <ErrorBoundary>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ErrorBoundary>
    </IoCContextProvider>
  </StrictMode>,
)

// eslint-disable-next-line no-console
console.info(
  `Writefull X loaded (version ${version}) (build #${import.meta.env.VITE_BUILD_NUMBER || 'local'})`,
)
